<template>
  <div :class="$style.container">
    <div :class="$style.video">
      <AppVideo
        ref="video"
        :source="content.url"
        :options="options"
        :isPlaying="isPlaying"
        :emit="['pause', 'ended']"
        :setVideoState="setVideoState"
        @pause="pauseVideo"
        @ended="pauseVideo"
      />

      <transition name="poster">
        <div
          v-if="!isPlaying"
          :class="$style.poster"
          :style="{
            backgroundImage: `url(${content.cover})`,
          }"></div>
      </transition>
    </div>
    <transition name="button">
      <button v-if="!isPlaying" :class="$style.button" @click="playVideo">
        <svg role="presentation">
          <use xlink:href="#plyr-play"></use>
        </svg>
      </button>
    </transition>
  </div>
</template>

<script>
import AppVideo from '@/components/AppVideo/index.vue';

export default {
  props: ['content'],

  components: {
    AppVideo,
  },

  data() {
    return {
      options: {},
      isPlaying: true,
    };
  },

  methods: {
    playVideo() {
      this.isPlaying = true;
    },

    pauseVideo() {
      this.isPlaying = false;
    },

    setVideoState(bool) {
      this.isPlaying = bool;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  position: relative;
}

.video {
  position: relative;
  width: 60%;
  margin: 0 auto;
  padding: 80px 0 60px;
  cursor: pointer;
  overflow: hidden;
}

.poster {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-size: cover;
  background-position: center;
  z-index: 2;
  opacity: 1;
  transform: scale(1.3, 1.3);
}

.button {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  width: 70px;
  height: 70px;
  margin: auto;
  padding: 0;
  z-index: 3;
  cursor: pointer;

  background: none;
  border: none;
  transform: translate3d(0, 50%, 0);

  &:focus {
    outline: none;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 2px solid #000;
    border-radius: 50%;
    z-index: -1;
    transition: all 0.35s ease-in-out;
  }

  svg {
    width: 16px;
    height: 22px;
    margin-left: 5px;
    fill: #000;
    transition: all 0.35s ease-in-out;
  }

  :global(.no-touchevents) &:hover {
    &::after {
      transform: scale(0.8, 0.8);
      background: #000;
    }

    svg {
      fill: #fff;
    }
  }
}

:global {
  .poster-enter-active,
  .poster-leave-active {
    transition: all 0.85s ease-in-out;
  }
  .poster-enter, .poster-leave-to {
    opacity: 0;
    transform: scale(1, 1);
    filter: blur(20px);
  }

  .button-enter-active,
  .button-leave-active {
    transition: all 0.65s ease-in-out;
  }
  .button-enter, .button-leave-to {
    opacity: 0;
    transform: translate3d(0, 50%, 0) scale(1.3, 1.3);
  }
}
</style>
